import { defineComponent, reactive } from 'vue';
import { MainTitle, ReportTabList } from '@/components';
import { BatteryContainer } from '@/containers';
export default defineComponent({
    name: 'Battery',
    components: {
        MainTitle,
        ReportTabList,
        BatteryContainer,
    },
    setup() {
        const state = reactive({
            tabname: 'hourly',
        });
        return { state };
    },
});
